document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.hash) return;

  const hash = window.location.hash;
  const target = document.querySelector(hash);
  if (!target) return;

  window.scrollTo(0, 0);

  window.addEventListener('load', function () {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  });
});